<template>
    <div class="page-container">
        <div class="page-inner page-left">
            <div class="teaching-book">
                <div class="teaching-book-img">
                    <img :src="bookInfo.fileUrl" @click="previewEvent(bookInfo.fileUrl)" />
                </div>
                <div class="teaching-book-desc">
                    <div class="teaching-book-title title1">{{bookInfo.bookName}}</div>
                    <div>共{{artiNum}}篇作文</div>
                </div>
            </div>
            <div class="teaching-course" v-for="(item,index) in artiList" :key="index">
                <div class="teaching-course-title title1">{{unitFormat(index+1)}}、{{item.artiUnit}}</div>
                <div class="teaching-course-inner" v-for="unit in item.bookArityVoList" :key="unit.artiId" @click="toDetail(unit)">
                    <div class="teaching-course-img">
                        <img :src="unit.artiImageFileUrl" @click.stop="previewEvent(unit.artiImageFileUrl)" />
                    </div>
                    <div class="teaching-course-desc">
                        <div class="teaching-course-desc-title">{{unit.artiName}}</div>
                        <div class="teaching-course-desc-info">{{unit.artiIntroduction}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-inner page-right">
            <div class="teaching-box-title title1">{{artiInfo.artiName}}</div>
            <div class="teaching-box">
                <div class="teaching-box-btn">
                    <el-radio-group v-model="teachingActive" fill="#fae8d4" text-color="#ef8b25">
                        <el-radio-button label="范文展示" value="1" />
                        <el-radio-button label="范文讲解" value="2" />
                        <el-radio-button label="训练秒评" value="3" />
                        <el-radio-button label="三步九法思维" value="4" />
                    </el-radio-group>
                </div>
            </div>
            <div v-show="teachingActive==1 && artiInfo.artiText" class="teaching-box-inner1">
                <div class="teaching-box-inner1-text" v-html="artiInfo.artiText">
                </div>
                <div class="teaching-box-inner1-btn" @click="copyEvent">
                    <el-icon>
                        <Document />
                    </el-icon>
                    复制文本
                </div>
            </div>
            <div v-show="teachingActive==2" class="teaching-box-inner1">
                <div class="teaching-box-inner1-text" v-html="resultInfo.comp_mod_analysis">
                </div>
            </div>
            <div v-show="teachingActive==3" class="teaching-box-inner3">
                <div v-show="!questionShow">
                    <div class="teaching-box-inner3-top">
                        <div class="activeColor">
                            <span class="teaching-box-score">{{questionResult.maxLevel || ''}}</span>
                        </div>
                        <div class="teaching-box-inner3-top-title2">章节最高成绩</div>
                        <div class="teaching-box-inner3-top-title3">当前章节您已完成
                            <span class="activeColor">{{questionResult.testCount || 0}}</span>次答题训练</div>
                    </div>
                    <div class="teaching-box-inner3-middle">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="xunlian-item">
                                    <div class="xunlian-item-top">
                                        <div class="weight">最近一次答题记录</div>
                                        <div class="xunlian-item-top-btn">本次成绩</div>
                                    </div>
                                    <div class="xunlian-item-middle">
                                        <div class="xunlian-item-middle-top">
                                            <div>
                                                <div>题目数量</div>
                                                <div><span class="weight">{{questionResultNew.questionCount || 0}}</span>道</div>
                                            </div>
                                            <div>
                                                <div>正确数量</div>
                                                <div><span class="weight">{{questionResultNew.maxCorrectNum || 0}}</span>道</div>
                                            </div>
                                            <div>
                                                <div>正确率</div>
                                                <div><span class="weight fc">{{correctFormat(questionResultNew.maxCorrectNum,questionResultNew.questionCount)}}</span>%</div>
                                            </div>
                                        </div>
                                        <div class="xunlian-item-middle-bottom">
                                            <div>答题耗时</div>
                                            <div class="weight">{{questionResultNew.continueTime || '暂未考试'}}</div>
                                        </div>
                                    </div>
                                    <div class="xunlian-item-bottom" v-if="questionResultNew.testCount && questionResultNew.testCount>0">
                                        <el-link type="warning" @click="openTest(2,1)">查看详情<el-icon class="el-icon--right"><ArrowRightBold /></el-icon></el-link>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="xunlian-item right">
                                    <div class="xunlian-item-top">
                                        <div class="weight">历史最高记录</div>
                                        <div class="xunlian-item-top-btn">最高成绩</div>
                                    </div>
                                    <div class="xunlian-item-middle">
                                        <div class="xunlian-item-middle-top">
                                            <div>
                                                <div>最高正确数量</div>
                                                <div><span class="weight">{{questionResult.maxCorrectNum || 0}}</span>道</div>
                                            </div>
                                            <div>
                                                <div>最高正确率</div>
                                                <div><span class="weight fb">{{correctFormat(questionResult.maxCorrectNum,questionResult.questionCount)}}</span>%</div>
                                            </div>
                                            <div>
                                                <div>练习次数</div>
                                                <div><span class="weight">{{questionResult.testCount || 0}}</span>次</div>
                                            </div>
                                        </div>
                                        <div class="xunlian-item-middle-bottom">
                                            <div>最高耗时</div>
                                            <div class="weight">{{questionResult.continueTime || '暂未考试'}}</div>
                                        </div>
                                    </div>
                                    <div class="xunlian-item-bottom" v-if="questionResult.testCount && questionResult.testCount>0">
                                        <el-link type="primary" @click="openTest(2,2)">查看详情<el-icon class="el-icon--right"><ArrowRightBold /></el-icon></el-link>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="teaching-box-inner3-bottom">
                        <div class="teaching-box-inner3-bottom-rule">
                            规则说明：
                        </div>
                        <div class="teaching-box-inner3-bottom-text">
                            <div>1、您可以反复的答题练习，系统记录最高的一次成绩；</div>
                            <div>2、必须完成一次答题后才能查看答案解析；</div>
                            <div>3、你的科目导师可以查看到您全部；</div>
                        </div>
                    </div>
                    <div class="teaching-box-inner3-footer">
                        <el-row>
                            <el-col :span="24">
                                <el-button color="#ef8b25" class="footer-btn footer-btn1" @click="openTest(1)">{{!questionResult.testCount?'开始答题':'重新答题'}}</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <template v-if="questionShow">
                    <div class="question-top">
                        <div class="question-top-left">
                            <span>
                                <span class="activeColor">{{questionNum+1}}</span>/
                                <span>{{questionList.length}}</span>
                            </span>
                            <span>{{typeFormat(questionInfo.questionType)}}</span>
                        </div>
                        <div class="question-top-right">
                            <div v-if="!isAnswer">
                                <el-icon color="#ef8b25">
                                    <Coin />
                                </el-icon>
                                <span>计时：</span>
                                <span class="activeColor">{{timeInfo}}</span>
                            </div>
                            <div @click="popupShow=true">
                                <el-icon color="#ef8b25">
                                    <Calendar />
                                </el-icon>题卡</div>
                            <div @click="backEvent">
                                <el-icon color="#ef8b25">
                                    <DArrowLeft />
                                </el-icon>返回上级</div>
                        </div>
                    </div>
                    <div class="problem-box">
                        <div class="problem-box-title">{{questionNum+1}}、{{questionInfo.questionName}}
                            <!-- <span class="activeColor">（{{questionInfo.questionScore}}分）</span> -->
                        </div>
                        <div class="problem-box-inner">
                            <div :class="getAnswerClass(item)" v-for="(item,index) in questionInfo.questionOption" :key="index" @click="questionClick(item)">
                                {{sortFormat(index+1)}}、{{item.content}}
                            </div>
                        </div>
                    </div>
                    <div class="answer-box" v-if="isAnswer">
                        <div class="">
                            <span class="activeColor">正确答案：</span>
                            {{rightSort}}
                        </div>
                        <div class="activeColor">
                            解析：
                        </div>
                        <div class="">
                            {{questionInfo.questionTranslation}}
                        </div>
                    </div>
                    <div class="questionFooter">
                        <el-button color="#ef8b25" plain @click="questionNum--" :disabled="questionNum===0">上一题</el-button>
                        <el-button color="#ef8b25" class="footer-btn1" v-if="!isAnswer" @click="submitEvent">提交答案</el-button>
                        <el-button color="#ef8b25" plain @click="questionNum++" :disabled="questionNum===questionList.length-1">下一题</el-button>
                    </div>
                </template>
            </div>
            <div v-show="teachingActive==4" class="teaching-box-inner4">
                <div class="teachingBox3-top">
                    <div class="teachingBox3-left">
                        什么是三步九法？
                    </div>
                    <div class="teachingBox3-right">
                        <span class="teachingBox3-title">开悟作文核心思想展示</span>
                    </div>
                </div>
                <img class="teachingBox3-img" src="@/assets/img/39.jpg" />
                <div class="teachingBox3-inner">
                    <el-divider>
                        <span style="color:#333;font-size:16px;">九法详解</span>
                    </el-divider>
                    <div class="teachingInner">
                        <div class="teachingInnerTitle">一、多头放想</div>
                        <div class="teachingInnersTitle">
                            从“上头”“下头”“后头”(家国情怀)、(身边事)“前头”(经历)、(憧憬)多角度搜索素材
                        </div>
                        <div class="teachingInnerTitle">二、多向放想</div>
                        <div class="teachingInnersTitle">
                            横向(同类扩展)、纵向(因果逻辑)、侧向(关联领域)反向(逆向思维)全方位扫描信息
                        </div>
                        <div class="teachingInnerTitle">三、多见放想</div>
                        <div class="teachingInnersTitle">
                            整合阅读积累、观察所得、人际交往中的“存量信息”
                        </div>
                        <div class="teachingInnerTitle">四、触发悟道</div>
                        <div class="teachingInnersTitle">
                            通过关键词碰撞激发灵感(如思维导图、关联词联想)
                        </div>
                        <div class="teachingInnerTitle">五、推导悟道</div>
                        <div class="teachingInnersTitle">
                            分析事物内在联系(如大与小、现象与本质)提炼规律性人知
                        </div>
                        <div class="teachingInnerTitle">六、升维悟道</div>
                        <div class="teachingInnersTitle">
                            通过背景铺垫、联系实际、系统聚焦，提升观点维度
                        </div>
                        <div class="teachingInnerTitle">七、守正悟道</div>
                        <div class="teachingInnersTitle">
                            坚守立意正确性(立德、真实、得体)，确保方向不偏
                        </div>
                        <div class="teachingInnerTitle">八、打包</div>
                        <div class="teachingInnersTitle">
                            将素材或句式(排比、比喻等)按逻辑打包为“套包”，增强系统张力
                        </div>
                        <div class="teachingInnerTitle">九、整合</div>
                        <div class="teachingInnersTitle">
                            依框架模型组装(如“三块辖N段”:导语 分述 结语:“一线串N包””:主题线串联套包)，形成完整行文路线
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog v-model="popupShow" title="题卡" width="500px" center>
            <div class="popup-inner">
                <div class="answer-popup">
                    <div class="answer-box-inner">
                        <div v-for="(item,index) in questionList" :key="index" @click="jumpEvent(index)" :class="['answer-box-inner-item',answerActive(item),answerCorrect(item)]">
                            {{index+1}}
                        </div>
                    </div>
                </div>
                <div class="answer-popup-tip">
                    <div class="answer-popup-title" v-if="!isAnswer">
                        绿色为已作答题目，可点击题号快速跳转到对应题目
                    </div>
                    <div class="answer-popup-title" v-if="isAnswer">
                        绿色为已答对题目，红色为答错题目，白色为未答题目，可点击题号 快速跳转到对应题目
                    </div>
                </div>
            </div>
            <template #footer v-if="!isAnswer">
                <div class="dialog-footer">
                    <el-button color="#ef8b25" class="footer-btn1" @click="dialogVisible = false">提交答案</el-button>
                </div>
            </template>
        </el-dialog>

        <el-image-viewer v-if="showPreview" :url-list="srcList" show-progress @close="showPreview = false" />
    </div>
</template>
<script lang="ts" setup>
import clipBoard from "vue-clipboard3"
import { ref, onMounted, computed, watch } from 'vue';
import { useStore } from "vuex"
import { getBookList, getBookDetail, getBookAnalysis, getQuestionResult, getQuestionList, getQuestionAnswer, submitQuestion,getQuestionResultNew,getQuestionAnswerNew } from "@/api/composition.js"
import { ElMessage } from 'element-plus'
let { toClipboard } = clipBoard()
const store = useStore();
const teachingActive = ref('1')
const resultInfo = ref({ comp_mod_analysis: '' })
const popupShow = ref(false)
const grade = ref(store.state.grade)
const term = ref(store.state.term)
const bookInfo = ref({})
const artiList = ref([])
const artiNum = ref(0)
const artiInfo = ref({})
const showPreview = ref(false)
const srcList = ref([])

onMounted(() => {
    getList(() => {
        toDetail(artiList.value[0].bookArityVoList[0])
    })
})

function previewEvent(url) {
    srcList.value = [url]
    showPreview.value = true
}

function getList(cb) {
    getBookList({
        grade: grade.value,
        term: term.value,
    }).then(res => {
        console.log(res)
        bookInfo.value = res.data.book || {};
        artiList.value = res.data.artiList || [];
        (res.data.artiList || []).forEach(item => {
            artiNum.value += item.bookArityVoList.length
        })
        cb && cb()
    })
}

function toDetail(item: any) {
    backEvent()
    teachingActive.value = '1';
    getDetail(item.artiId)
    getAnalysis(item.artiId)
    if (store.state.userInfo && store.state.userInfo.userId && sessionStorage.getItem('token')) {
        getResult(item.artiId)
        getResultNew(item.artiId)
    }
}
function getDetail(artiId: string) {
    getBookDetail(artiId).then((res: any) => {
        artiInfo.value = res.data;
        const artiText = res.data.artiText;
        artiInfo.value.artiNum = artiText.replace(/<[^>]*>/g, '').length || 0;
    })
}
function getAnalysis(artiId: string) {
    getBookAnalysis(artiId).then((res: any) => {
        resultInfo.value.comp_mod_analysis = res.data || ''
    })
}
// 训练秒评相关
const questionShow = ref(false)
const questionInfo = ref({
    questionOption: []
})
const questionNum = ref(0)
const isAnswer = ref(false)
const questionList = ref([])
const questionResult = ref({})
const questionResultNew =ref({})
const questionAnswer = ref({})
const nowAnswer = ref([])
const timeInfo = ref('00:00:00')
let timer = null
let startTime = ''
let questionCorrect = {}
watch(() => questionNum.value, () => {
    getQuestionInfo(() => {
        nowAnswer.value = questionInfo.value.questionId in questionAnswer.value ? questionAnswer.value[questionInfo.value.questionId] : []
    })
}, {
        immediate: true
    })
function getResult(artiId: string) {
    getQuestionResult(artiId).then((res: any) => {
        questionResult.value = res.data || {}
    })
}
function getResultNew(artiId: string) {
    getQuestionResultNew(artiId).then((res: any) => {
        questionResultNew.value = res.data || {}
    })
}

function correctFormat(rightNum,num){
    if(rightNum && num){
        return (rightNum/num*100).toFixed(2)
    }else{
        return 0
    }
}
function getAnswerClass(item) {
    let arr = ['problem-box-inner-item']
    if (isAnswer.value) {
        if (nowAnswer.value.includes(item.questionAnsswerId)) {
            console.log('++++')
            // 已选
            if (item.isCorrect == 1) { //正答
                arr.push('active-right')
            } else { //错答
                arr.push('active-error')
            }
        }
        // else{//未选
        // 	if(item.isCorrect==1){
        // 		arr.push('active-error')
        // 	}
        // }
    } else {
        if (nowAnswer.value.includes(item.questionAnsswerId)) {
            arr.push('active')
        }
    }
    return arr
}
function openTest(flag: number,type=0) {
    if (!store.state.userInfo || !store.state.userInfo.userId || !sessionStorage.getItem('token')) {
        return store.dispatch('setLoginFlag')
    }
    if (!questionResult.value.questionCount) {
        return ElMessage.warning('习题未发布，暂不能练习')
    }
    if (flag == 2) {
        isAnswer.value = true
    }
    getQuestion(() => {
        questionShow.value = true
        if (flag == 1) {
            let time = 0;
            startTime = getCurrentTime()
            timer = setInterval(() => {
                timeInfo.value = msToTime(time)
                time += 1000;
            }, 1000)
        }
    },type)
}
function msToTime(duration) {
    var seconds = Math.floor((duration / 1000) % 60),
        minutes = Math.floor((duration / (1000 * 60)) % 60),
        hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    return hours + ":" + minutes + ":" + seconds;
}
function getQuestion(cb: any,type=1) {
    getQuestionList(artiInfo.value.artiId).then((res: any) => {
        questionList.value = res.data || []
        let correct = {}
        questionList.value.forEach(item => {
            const questionOption = JSON.parse(item.questionOption)
            let arr = []
            questionOption.forEach(option => {
                if (option.isCorrect == 1) {
                    arr.push(option.questionAnsswerId)
                }
            })
            correct[item.questionId] = arr;
        })
        questionCorrect = correct;
        cb ? getQuestionInfo(cb) : getQuestionInfo()
        if (isAnswer.value) {
            getAnswer(cb,type)
        }
    })
}

function getQuestionInfo(cb) {
    let obj = {},
        val = questionNum.value;
    if (questionList.value.length) {
        obj = {
            ...questionList.value[val],
            questionOption: questionList.value[val].questionOption ? JSON.parse(questionList.value[val]
                .questionOption) : []
        }
    }
    questionInfo.value = obj;
    cb && cb()
}

function getAnswer(cb,type) {
    let api = type==2?getQuestionAnswer:getQuestionAnswerNew;
    api({ artiId: artiInfo.value.artiId }).then((res: any) => {
        let obj = {};
        (res.data || []).map((item: any) => {
            const answer = item.answer;
            obj[item.questionId] = answer ? answer.split(',').map(index => {
                return index
            }) : []
        })
        questionAnswer.value = obj;
        const questionId = questionList.value[questionNum.value].questionId
        nowAnswer.value = obj[questionId];
        cb && cb()
    })
}

function typeFormat(type: number) {
    switch (String(type)) {
        case '1':
            return '判断题';
        case '2':
            return '单选题';
        case '3':
            return '多选题';
        default:
            return type;
    }
}

function sortFormat(index: number) {
    return String.fromCharCode(64 + index)
}
function unitFormat(num) {
    var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];

    if (!num || isNaN(num)) {
        return "零";
    }

    var english = num.toString().split("");
    var result = "";

    for (var i = 0; i < english.length; i++) {
        var des_i = english.length - 1 - i;
        result = arr2[i] + result;
        var arr1_index = english[des_i];
        result = arr1[arr1_index] + result;
    }

    result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
    result = result.replace(/零+/g, '零');
    result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
    result = result.replace(/亿万/g, '亿');
    result = result.replace(/零+$/, '');
    result = result.replace(/^一十/g, '十');

    return result;
}
function submitEvent() {
    let valid = true,
        keys = Object.keys(questionAnswer.value);
    if (!keys.length) {
        valid = false;
    } else {
        valid = keys.some(item => {
            return questionAnswer.value[item].length
        })
    }
    if (!valid) {
        return ElMessage.warning('提交前至少答一题')
    }
    let answerArr = questionList.value.map(item => {
        if (item.questionId in questionAnswer.value) {
            return {
                questionId: item.questionId,
                answer: questionAnswer.value[item.questionId].join(',')
            }
        } else {
            return {
                questionId: item.questionId,
                answer: ''
            }
        }
    })
    const params = {
        "answerJsonArrayStr": JSON.stringify(answerArr),
        "artiId": artiInfo.value.artiId,
        "beginTime": startTime,
        "endTime": getCurrentTime()
    }
    submitQuestion(params).then(() => {
        ElMessage.success('提交成功')
        backEvent()
        getResult(artiInfo.value.artiId)
        getResultNew(artiInfo.value.artiId)
    })

}
const rightSort = computed(() => {
    const sort: any[] = []
    if (questionInfo.value.questionOption) {
        questionInfo.value.questionOption.forEach((item: any, index: number) => {
            if (item.isCorrect == 1) {
                sort.push(String.fromCharCode(64 + index + 1))
            }
        })
    }
    return sort.length ? sort.join('、') : ''
})
function answerActive(item: any) {
    return (item.questionId in questionAnswer.value && questionAnswer.value[item.questionId]
        .length) ? 'active' : ''
}
function answerCorrect(item: any) {
    if (isAnswer.value) {
        let correct: any[] = questionCorrect[item.questionId] || [], anwer = questionAnswer.value[item.questionId] || [], valid = true;
        if (!anwer.length) {
            return ''
        } else if (anwer.length != correct.length) {
            valid = false;
        } else {
            valid = correct.every(option => {
                return anwer.some(anwerItem => {
                    return anwerItem == option
                })
            })
        }
        return valid ? '' : 'warning'
    }
    return ''
}
function jumpEvent(index) {
    questionNum.value = index;
    popupShow.value = false;
}
function backEvent() {
    questionShow.value = false
    questionInfo.value = {
        questionOption: []
    }
    questionNum.value = 0
    isAnswer.value = false
    questionList.value = []
    questionAnswer.value = {}
    nowAnswer.value = []
    questionCorrect = {}
    if (timer) {
        timeInfo.value = '00:00:00'
        clearInterval(timer)
        timer = null
    }
}
function getCurrentTime() {
    const now = new Date(); // 获取当前时间
    const year = now.getFullYear(); // 获取年份
    const month = now.getMonth() + 1; // 获取月份，月份从0开始，所以要加1
    const day = now.getDate(); // 获取日
    const hours = now.getHours(); // 获取小时
    const minutes = now.getMinutes(); // 获取分钟
    const seconds = now.getSeconds(); // 获取秒

    // 格式化输出，保证月份和日期是两位数
    const formattedMonth = month < 10 ? '0' + month : month;
    const formattedDay = day < 10 ? '0' + day : day;
    const formattedHours = hours < 10 ? '0' + hours : hours;
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

    // 组合成完整的日期时间字符串
    return `${year}-${formattedMonth}-${formattedDay} ${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

function questionClick(item) {
    if (isAnswer.value) return;
    let answer = []
    if (questionInfo.value.questionId in questionAnswer.value) {
        answer = questionAnswer.value[questionInfo.value.questionId];
        if (questionInfo.value.questionType == 3) {
            const answerIndex = answer.indexOf(item.questionAnsswerId)
            if (answerIndex > -1) {
                answer.splice(answerIndex, 1)
            } else {
                answer.push(item.questionAnsswerId)
            }
        } else {
            if (answer.length) {
                answer.splice(0, 1, item.questionAnsswerId)
            } else {
                answer.push(item.questionAnsswerId)
            }
        }
    } else {
        answer.push(item.questionAnsswerId)
    }
    nowAnswer.value = answer;
    questionAnswer.value[questionInfo.value.questionId] = answer
}

async function copyEvent() {
    try {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = artiInfo.value.artiText;
        const val = tempDiv.textContent || tempDiv.innerText || '';
        console.log(val)
        await toClipboard(val)
        ElMessage.success('复制成功')
    } catch{
        ElMessage.error('复制失败')
    }
}
// 训练秒评相关
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.teaching-book {
    display: flex;
    margin-bottom: 20px;
    &>div+div {
        margin-left: 10px;
    }
    .teaching-book-img {
        width: 90px;
        height: 110px;
        background: #eee;
        border-radius: 10px;
        margin-left: 15px;
        img {
            width: 100%;
            height: 100%;
            border-radius: 10px;
        }
    }
    .teaching-book-desc {
        flex: 1;
        color: #999;
        font-size: 12px;
        .teaching-book-title {
            margin-bottom: 15px;
        }
    }
}

.teaching-course {
    border-top: 1px solid $base-border-color;
    padding: 10px 0 20px;
    .teaching-course-title {
        margin-bottom: 15px;
        margin-left: 15px;
    }
    .teaching-course-inner {
        display: flex;
        padding: 15px;
        border-radius: 10px;
        background: #f7f7f7;
        cursor: pointer;
        .teaching-course-img {
            width: 120px;
            height: 90px;
            background: #eee;
            border-radius: 10px;
            margin-right: 10px;
            img {
                width: 100%;
                height: 100%;
                border-radius: 10px;
            }
        }
        .teaching-course-desc {
            flex: 1;
            color: #999;
            font-size: 12px;
            .teaching-course-desc-title {
                color: $base-text-color;
                font-size: 14px;
                margin-bottom: 6px;
            }
            .teaching-course-desc-info {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
    .teaching-course-inner+.teaching-course-inner {
        margin-top: 10px;
    }
}

.teaching-box {
    border-bottom: 1px solid $base-border-color;
}

.teaching-box-inner1 {
    padding: 10px;
    font-size: 14px;
    .teaching-box-inner1-text {
        text-indent: 2em;
        margin-bottom: 10px;
        line-height: 24px;
    }
    .teaching-box-inner1-btn {
        text-align: right;
        cursor: pointer;
    }
}

.teaching-box-inner3 {
    padding: 10px;
    .teaching-box-inner3-top {
        text-align: center;
        padding: 20px;
        line-height: 30px;
        border-bottom: 1px dashed $base-border-color;
        .teaching-box-score {
            font-size: 30px;
            font-weight: bold;
            color: $base-color;
        }
        .teaching-box-inner3-top-title2 {
            font-weight: bold;
        }
        .teaching-box-inner3-top-title3 {
            font-size: 12px;
        }
    }
    .teaching-box-inner3-middle {
        text-align: center;
        padding: 20px 0;
        font-size: 12px;
        color: $base-color;
        .teaching-box-inner3-middle-num {
            font-size: 18px;
            font-weight: bold;
            color: #2c3e50;
            margin-bottom: 4px;
        }
    }
    .teaching-box-inner3-bottom {
        padding: 15px;
        border-radius: 10px;
        background: #f7f7f7;
        border: 1px solid $base-border-color;
        font-size: 14px;
        .teaching-box-inner3-bottom-rule {
            text-align: center;
            color: $base-color;
            font-weight: bold;
            margin-bottom: 10px;
        }
        .teaching-box-inner3-bottom-text {
            width: 80%;
            margin: auto;
            color: $base-text-color;
        }
    }
    .teaching-box-inner3-footer {
        margin-top: 20px;
        text-align: center;
        .footer-btn {
            width: 80%;
            margin: auto;
            height: 40px;
            line-height: 40px;
        }
    }
}

.teaching-box-inner4 {
    padding: 20px;
    .teachingBox3-top {
        display: flex;
        height: 40px;
        line-height: 40px;

        .teachingBox3-left {
            flex: 1;
            color: $base-color;
            font-weight: bold;
            text-align: center;
            font-size: 16px;
        }

        .teachingBox3-right {
            flex: 1;
            font-size: 14px;
            height: 0;
            border-left: 30px solid transparent;
            border-top: 40px solid #666;
            border-radius: 6px;
            position: relative;
            color: #fff;

            .teachingBox3-title {
                position: absolute;
                top: -40px;
                left: 4px;
            }
        }
    }

    .teachingBox3-img {
        width: 100%;
        padding: 10px 10px 0;
        box-sizing: border-box;
    }

    .teachingBox3-inner {
        padding: 0 10px 10px;
    }

    .teachingInner {
        padding: 0 20px 20px;

        .teachingInnerTitle {
            font-weight: 600;
            line-height: 30px;
        }

        .teachingInnersTitle {
            color: #999;
            text-indent: 2em;
        }
    }
}

.question-top {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid $base-border-color;
    font-size: 14px;
    .question-top-left {
        font-weight: bold;
        &>span+span {
            margin-left: 6px;
        }
    }
    .question-top-right {
        display: flex;
        &>div+div {
            margin-left: 6px;
        }
        &>div {
            display: flex;
            align-items: center;
            line-height: 1;
            cursor: pointer;
            i {
                margin-right: 4px;
            }
        }
    }
}

.problem-box {
    margin-bottom: 20px;

    .problem-box-title {
        padding: 15px 0;
    }

    .problem-box-inner-item {
        padding: 6px 15px;
        background: #f5f5f5;
        margin-bottom: 8px;

        &.active {
            background: #fdeedf;
        }
        &.active-right {
            background: #87d4cc;
        }
        &.active-error {
            background: #dd0000;
        }
    }
}

.answer-box {
    padding-top: 20px;
    border-top: 1px dashed $base-border-color;
    line-height: 24px;
}

.questionFooter {
    width: 100%;
    margin: 20px auto;
    display: flex;
    justify-content: space-between;
    .el-button {
        width: 100%;
    }
}

.answer-popup {
    max-height: 60vh;
    overflow: auto;
}

.answer-popup-tip {
    margin-top: 10px;

    .answer-popup-title {
        font-size: 12px;
        color: #999;
        margin-bottom: 6px;
    }
}

.answer-box-inner {
    display: flex;
    flex-wrap: wrap;

    .answer-box-inner-item {
        width: 30px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border: 1px solid $base-color;
        color: $base-color;
        border-radius: 6px;
        margin-right: 8px;
        margin-bottom: 8px;
        cursor: pointer;

        &.active {
            background: $base-color;
            color: #fff;
        }

        &.warning {
            border-color: #dd0000;
            background: #dd0000;
            color: #fff;
        }
    }
}

.teaching-box-title {
    text-align: center;
    line-height: 28px;
    margin-bottom: 10px;
}

.xunlian-item{
    border:1px solid #ef8b25;
    width:100%;
    border-radius: 8px;
    overflow: hidden;
    .xunlian-item-top{
        background:#fffaf4;
        padding:10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .xunlian-item-top-btn{
            padding: 4px 10px;
            background: #fae8d4;
            border-radius: 12px;
        }
    }
    .xunlian-item-bottom{
        background:#fffaf4;
        padding:10px;
        text-align:center;
    }
    .xunlian-item-middle{
        padding:10px;
        color: #2c3e50;
        .xunlian-item-middle-top{
            display: flex;
            padding-bottom:10px;
            &>div+div{
                border-left:1px dashed $base-border-color;
            }
            &>div{
                flex:1;
                text-align:center;
                &>div+div{
                    margin-top:6px;
                }
            }
            
        }
        .xunlian-item-middle-bottom{
            display: flex;
            justify-content: space-between;
            padding-top:10px;
        }
        &>div+div{
            border-top: 1px dashed $base-border-color;
        }
    }

    &.right{
        border-color:#409eff;
        color:#409eff;
        .xunlian-item-top{
        background:#f2f6fa;
        .xunlian-item-top-btn{
           background: #e2f0ff;
        }
        }
        .xunlian-item-bottom{
        background:#f2f6fa;
    }
    }

    .weight{
                font-size: 16px;
                font-weight: bold;
            }
            .fc{
                color: #ef8b25;
            }
            .fb{
                color:#409eff;
            }
}
</style>

